import React from "react";
import PropTypes from "prop-types";

export const Tooltip = ({ arrowPosition, tooltipText, ...props }) => {
  return (
    <div className={`c-tooltip c-tooltip--${arrowPosition}`}>
      {tooltipText}
    </div>
  );
};

Tooltip.propTypes = {
  arrowPosition: PropTypes.oneOf(["top", "right", "bottom", "left"]),
};

Tooltip.defaultProps = {
  arrowPosition: "top",
  tooltipText: "Tooltip"
};
